<template>
    <div id="reports_page" class="container-fluid">
        <router-link v-if="hasClientsConnected" :to="{ path: '/reports/create' }" class="btn btn-secondary main-button pull-right">Create New Report</router-link>
        <button v-if="!hasClientsConnected" class="btn btn-secondary main-button pull-right" style="pointer-events:initial !important;" title="You need at least a client and a data source connected to be able to create a report" disabled>Create New Report</button>

        <v-client-table :data="tableData" :columns="columns" :options="options" @pagination="updateTooltips" @filter="updateTooltips" @sorted="updateTooltips">
            <div slot="sources" slot-scope="props" class="sources">
                <img v-for="(accounts, data_source_name) in data_connection_accounts[props.row.id]" :title="createTooltip(props.row.id, data_source_name)" :src="$store.state.app_url + '/images/data_sources/' + accounts[0].abbreviation + '.png'">
            </div>

            <div slot="actions" slot-scope="props" class="text-right">
                <template v-if="props.row.is_ga4 > 0">
                    <router-link class="btn btn-info reverse" :to="{ path: '/reporting/report/skb/' + props.row.id}" target='_blank'>View KBPG</router-link>
                </template>
                <template v-if="props.row.is_built">
                    <router-link class="btn btn-info reverse" :to="{ path: '/reporting/report/' + props.row.id}" target='_blank'>View</router-link>
                </template>
                <template v-else>
                    <router-link class="btn btn-info reverse disabled" :to="{ path: ''}" title="You need to build the report before viewing it">View</router-link>
                </template>
                <router-link v-if="getUserPermissions().build_reports" class="btn btn-info reverse" :to="{ path: '/reports/build/' + props.row.id}" :disabled="!data_sources_and_accounts[props.row.id]">Builder</router-link>
                <router-link v-if="getUserPermissions().edit_reports" :to="{ path: `/reports/edit/${props.row.id}` }" class="btn btn-info reverse">Admin</router-link>
                <button v-if="getUserPermissions().edit_reports" :disabled="props.row.is_manual_pull_running === 1" @click="runManualDataPulling(props.row.id)" class="btn btn-info reverse btn-icon" :title="props.row.is_manual_pull_running === 1 ? 'Manual data pulling is running...' : 'Pull data'">
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </button>
                <button v-if="getUserPermissions().delete_reports" @click="remove(props.row.id)" class="btn btn-danger reverse btn-icon">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                data_connection_accounts: {},
                data_sources_and_accounts:{},
                hasClientsConnected:false,
                columns: ['name', 'client_name', 'sources', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        name:        'Report Name',
                        client_name: 'Client Name',
                        sources:     'Data Sources',
                        actions:     ''
                    },
                    sortable: ['name', 'client_name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} reports|{count} reports|One report',
                        filter: '',
                        filterPlaceholder: 'Search reports...',
                        noResults: 'No matching reports'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/reports?client_id=${this.$route.params.client_id || ''}`),
                    axios.get('/api/data-connections/reports'),
                    axios.get('/api/clients/connected'),
                    axios.get('/api/reports/data-sources-and-accounts')
                ])
                .then(axios.spread((reports, dataConnectionAccounts, clientsConnected, dataSourcesAndAccounts) => {
                    this.tableData                 = reports.data;
                    this.data_connection_accounts  = dataConnectionAccounts.data.data;
                    this.hasClientsConnected       = clientsConnected.data > 0;
                    this.data_sources_and_accounts = dataSourcesAndAccounts.data;

                    this.updateTooltips();
                }));
            },

            createTooltip(reportId, dataSourceName) {
                let tooltip = `<table style="font-size:1.28rem" class="table table-borderless table-sm table-tooltip"><thead><tr><td>Source Name</td><td>Account Name</td></tr></thead><tbody>`;

                _.each(this.data_connection_accounts[reportId][dataSourceName], account => {
                    tooltip += `<tr><td>${account.name_given_by_user}</td><td>${account.primary_name_in_source || ''} (${account.primary_account_id || ''})</td></tr>`;
                });

                tooltip += '</tbody></table>';

                return tooltip;
            },

            updateTooltips() {
                setTimeout(() => {
                    $('#reports_page').find('.sources img').each(function() {
                        if ($(this).hasClass('tooltipstered')) {
                            $(this).tooltipster('destroy');
                        }
                    });

                    $('#reports_page').find('.sources img').tooltipster({
                        contentAsHTML:     true,
                        animation:         false,
                        animationDuration: false,
                        interactive:       true,
                        side:              'bottom'
                    });
                }, 0);
            },

            runManualDataPulling(reportId) {
                axios.get(`/api/reports/${reportId}/run-manual-data-pulling`).then(response => {
                    axios.get(`/api/reports?client_id=${this.$route.params.client_id || ''}`).then(response => {
                        this.tableData = response.data;
                    });

                    this.$notify({
                        type: 'success',
                        text: response.data.message
                    });
                });
            },

            remove(reportId) {
                this.confirmation(this.messages.WARNING_REPORT_DELETE, () => {
                    axios.delete(`/api/reports/${reportId}`).then(response => {
                        this.fetchServerData();

                        this.$notify({
                            type: 'success',
                            text: this.messages.REPORT_DELETED
                        });
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    #reports_page {
        .fa-trash-o,
        .fa-refresh {
            font-size: 1.4rem;
            padding: .1rem;
        }

        .sources {
            img {
                max-height: 2.6rem;
            }
        }

        button:disabled, a.disabled {
            pointer-events: initial !important;
            cursor: not-allowed;

            &:hover{
                color:white;
            }
        }
        .VueTables__table{
            table-layout:unset;
        }
        .VueTables__table th, .VueTables__table td{
            width:9rem;
            @media screen and (min-width: 960px) {
               width:13rem;
            }
            @media screen and (min-width: 1100px) {
                width:auto;
            }

            &:last-child{
                @media screen and (min-width: 864px) {
                    white-space:nowrap;
                }
            }
        }
        .VueTables__table td{
            @media screen and (max-width: 864px) {
                padding-left:0;
                padding-right:0;
            }
        }
    }
</style>
